import { TemplateRef } from '@angular/core';

import { ColumnDefinition } from '@app/shared/models';

export const GET_RFX_COLUMNS = (
  createDateTemplate: TemplateRef<unknown>
): ColumnDefinition[] => [
  {
    def: 'name',
    header: 'Name',
    visible: true,
    sortable: true
  },
  {
    def: 'authorName',
    header: 'Author',
    visible: true,
    sortable: true
  },
  {
    def: 'status',
    header: 'Stage Status',
    visible: true,
    sortable: false
  },
  {
    def: 'dateCreated',
    header: 'Create Date',
    cell: createDateTemplate,
    visible: true,
    sortable: true
  },
  {
    def: 'id',
    header: 'Id Tender',
    visible: true,
    sortable: false
  }
];
